"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Input = void 0;
var React = require("react");
var react_1 = require("react");
var Input_style_1 = require("./Input.style");
var Icon_1 = require("../Icon");
exports.Input = function (props) {
    var label = props.label, icon = props.icon, id = props.id, value = props.value, placeholder = props.placeholder, required = props.required, error = props.error, iconClick = props.iconClick;
    var _a = react_1.useState(false), isFocus = _a[0], setFocus = _a[1];
    return (React.createElement(Input_style_1.default.Wrapper, { onBlur: function () {
            setFocus(false);
        }, isFocus: isFocus, labelActive: isFocus || value },
        React.createElement(Input_style_1.default.Label, { htmlFor: id },
            label,
            required ? '*' : null),
        React.createElement(Input_style_1.default.Input, __assign({ onFocus: function () {
                setFocus(true);
            }, 
            // id={id}
            placeholder: placeholder }, props)),
        icon ? (React.createElement(Input_style_1.default.IconWrap, { onClick: function () {
                if (iconClick) {
                    iconClick();
                }
            } },
            React.createElement(Icon_1.default, { icon: icon, size: 35 }))) : null,
        error ? React.createElement(Input_style_1.default.FieldError, null, error) : null));
};
exports.default = exports.Input;
//# sourceMappingURL=Input.js.map